module.exports = require("./fr-CA.d.ts");